import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["start", "end"]

  declare readonly startTarget: HTMLInputElement;
  declare readonly endTarget: HTMLInputElement;

  connect() {
    this.sync();
  }

  sync() {
    if (this.startTarget.value) {
      this.endTarget.min = this.startTarget.value;
    } else {
      this.endTarget.removeAttribute("min");
    }
    if (this.endTarget.value) {
      this.startTarget.max = this.endTarget.value;
    } else {
      this.startTarget.removeAttribute("max");
    }
  }
}
